import { getAnalytics } from "@tm/insurance/analytics";
import { TextNodeType } from "@tm/ui-widgets/components";
import {
  IntersectionObserverData,
  useIntersectionObserver,
} from "@tm/ui/hooks";
import { useCallback, useRef } from "react";
import FormattedText from "../FormattedText/FormattedText";
import {
  OfferedByContainer,
  OfferedByIcon,
  OfferedByIconContainer,
  OfferedByTitle,
} from "./OfferedBySection.style";

interface IOfferedBy {
  data: {
    title: TextNodeType;
    description?: TextNodeType;
    icons: string[];
  };
}

const OfferedBySection = ({ data }: IOfferedBy) => {
  const { title, description, icons } = data;
  const analytics = getAnalytics();
  const hasTracked = useRef<boolean>(false);

  // Track component view when it comes into viewport
  const handleIntersection = useCallback((data: IntersectionObserverData) => {
    if (!hasTracked.current) {
      analytics?.trackCommonLandingEvents({
        actionType: "offered_by_section_seen",
      });
    }
    hasTracked.current = true;
  }, []);

  const { ref: offeredBySectionRef } = useIntersectionObserver(
    handleIntersection,
    {
      threshold: 0.5, // Trigger when 50% of component is visible
      triggerOnLeaveViewport: true,
    }
  );
  return (
    <OfferedByContainer ref={offeredBySectionRef}>
      <OfferedByTitle>
        <FormattedText value={title} />
      </OfferedByTitle>
      <OfferedByIconContainer>
        {icons?.map((iconUrl: string, index: number) => (
          <OfferedByIcon
            key={index}
            src={iconUrl}
            alt={`Insurance Provider ${index + 1}`}
          />
        ))}
      </OfferedByIconContainer>
    </OfferedByContainer>
  );
};

export default OfferedBySection;
